/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import styled from "styled-components";

import {
	columnWrapper,
	rowWrapper
} from "../../../styled/styled-extends";

// EXPORT

// BodyWrapper?

export const HeaderLogoWrapper = styled.a`
	border-radius: 999px;
	cursor: pointer;
	height: 24px;
	${rowWrapper}

	svg {
		circle,
		path,
		rect {
			fill: #FFF;
		}
	}
`;

export const HeaderNavIconWrapper = styled.a`
	background-color: #FFF;
	border-radius: 999px;
	cursor: pointer;
	height: 24px;
	width: 24px;
	${rowWrapper}
`;

export const HeaderWrapper = styled.div`
	align-items: center;
	background-color: #000;
	padding: 16px;
	width: 100%;
	${rowWrapper}

	> div {
		flex: 1;
		justify-content: center;
		${rowWrapper}

		&:first-child {
			justify-content: flex-start;
		}

		&:last-child {
			justify-content: flex-end;
		}
	}
`;

export const ComponentWrapper = styled.div`
	flex: 1;
	width: 100%;
	${columnWrapper}
`;
